export default "__VITE_ASSET__YomX$OQJ__"